var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',_vm._g(_vm._b({staticClass:"publish-button",class:[
    `publish-button--${_vm.tone}`,
    `publish-button--${_vm.layout}`,
    { 'publish-button--custom-text-color': _vm.textColor },
  ],style:(_vm.buttonStyle),attrs:{"type":_vm.tone === 'primary' ? 'info' : 'default'}},'van-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }